var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 66,
    viewBox: "0 0 64 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3121 43.2811C9.41298 47.4088 45.4596 45.1416 50.5452 45.1419C54.9627 37.8774 54.0841 31.0194 45.4599 17.9573C43.3617 15.5912 41.5136 12.7922 35.5184 8.17613C33.4672 7.05884 31.0999 4.4704 29.0902 3.3101C27.7912 2.5601 26.4072 6.95722 22.7383 8.3031C19.8148 9.37557 18.669 12.4184 16.3169 14.4163C10.6518 19.2285 12.3169 21.3445 9.56691 26.1077C6.81691 30.8708 6.85426 37.8149 8.3121 43.2811Z",
    fill: "#FBE54D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5452 45.1419L50.5451 46.3919L51.248 46.3919L51.6132 45.7914L50.5452 45.1419ZM8.3121 43.2811L9.51988 42.9589L8.3121 43.2811ZM16.3169 14.4163L17.1262 15.369L16.3169 14.4163ZM45.4599 17.9573L46.503 17.2685L46.454 17.1944L46.3951 17.1279L45.4599 17.9573ZM35.5184 8.17613L36.281 7.1857L36.2029 7.12556L36.1163 7.07842L35.5184 8.17613ZM22.7383 8.3031L23.1688 9.47663L22.7383 8.3031ZM50.5452 43.8919C49.2438 43.8918 45.9905 44.0354 41.9106 44.1823C37.8026 44.3302 32.8009 44.484 27.9279 44.5093C23.0455 44.5346 18.3318 44.4305 14.7869 44.0696C13.0061 43.8883 11.5819 43.6478 10.5962 43.3497C10.1005 43.1997 9.77766 43.0531 9.58958 42.9318C9.38865 42.8022 9.47487 42.7901 9.51988 42.9589L7.10432 43.6032C7.28695 44.2879 7.78379 44.7419 8.23431 45.0326C8.69769 45.3315 9.26712 45.5595 9.87235 45.7426C11.0886 46.1105 12.7008 46.3701 14.5337 46.5567C18.216 46.9316 23.0383 47.0347 27.9409 47.0093C32.8529 46.9838 37.8851 46.8288 42.0006 46.6807C46.1442 46.5315 49.3037 46.3918 50.5451 46.3919L50.5452 43.8919ZM9.51988 42.9589C8.10603 37.6577 8.1308 31.0951 10.6494 26.7327L8.48438 25.4827C5.50302 30.6465 5.60249 37.9721 7.10432 43.6032L9.51988 42.9589ZM10.6494 26.7327C12.0923 24.2336 12.4685 22.2146 13.0217 20.7124C13.5748 19.2108 14.4386 17.652 17.1262 15.369L15.5077 13.4636C12.5302 15.9928 11.394 17.8982 10.6758 19.8484C9.95779 21.798 9.79155 23.2186 8.48438 25.4827L10.6494 26.7327ZM44.4167 18.646C48.7026 25.1373 50.9618 29.9428 51.6619 33.9394C52.3473 37.8512 51.5538 41.0775 49.4771 44.4924L51.6132 45.7914C53.9541 41.9418 54.9301 38.1068 54.1244 33.508C53.3336 28.994 50.8414 23.8394 46.503 17.2685L44.4167 18.646ZM28.4652 4.39263C29.3502 4.90358 30.3474 5.75249 31.4806 6.71283C32.5537 7.62232 33.7601 8.64181 34.9205 9.27384L36.1163 7.07842C35.2255 6.59317 34.2227 5.75979 33.0969 4.80566C32.0312 3.90238 30.8399 2.87692 29.7152 2.22757L28.4652 4.39263ZM34.7558 9.16656C40.631 13.6902 42.378 16.3659 44.5246 18.7866L46.3951 17.1279C44.3454 14.8165 42.3962 11.8941 36.281 7.1857L34.7558 9.16656ZM17.1262 15.369C18.4142 14.2749 19.4202 12.8455 20.2768 11.809C21.1878 10.7067 22.0296 9.89456 23.1688 9.47663L22.3078 7.12957C20.5236 7.78411 19.3306 9.02957 18.3498 10.2163C17.3146 11.4688 16.5717 12.5598 15.5077 13.4636L17.1262 15.369ZM23.1688 9.47663C25.3519 8.67578 26.8016 6.98814 27.7677 5.81545C28.2986 5.17109 28.6202 4.76338 28.8948 4.51995C29.0241 4.40537 29.0387 4.42583 28.9558 4.45084C28.8133 4.49383 28.618 4.48085 28.4652 4.39263L29.7152 2.22757C29.2377 1.95186 28.7149 1.91222 28.2337 2.05739C27.8122 2.18456 27.4769 2.43602 27.2364 2.64922C26.7715 3.06138 26.2743 3.69644 25.8382 4.22584C24.8703 5.40068 23.7936 6.58454 22.3078 7.12957L23.1688 9.47663Z",
    fill: "#351771"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8374,
    cy: 12.4013,
    r: 0.5,
    transform: "rotate(120 23.8374 12.4013)",
    fill: "#351771"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1091,
    cy: 16.5998,
    r: 0.5,
    transform: "rotate(120 19.1091 16.5998)",
    fill: "#351771"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9714,
    cy: 8.43716,
    r: 0.5,
    transform: "rotate(120 24.9714 8.43716)",
    fill: "#351771"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.4752,
    cy: 7.57339,
    r: 0.5,
    transform: "rotate(120 25.4752 7.57339)",
    fill: "#351771"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.9752,
    cy: 6.70743,
    r: 0.5,
    transform: "rotate(120 25.9752 6.70743)",
    fill: "#351771"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.1714,
    cy: 7.97525,
    r: 0.5,
    transform: "rotate(120 32.1714 7.97525)",
    fill: "#351771"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9354,
    cy: 9.5712,
    r: 0.5,
    transform: "rotate(120 28.9354 9.5712)",
    fill: "#351771"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.3053,
    cy: 10.9394,
    r: 0.5,
    transform: "rotate(120 29.3053 10.9394)",
    fill: "#351771"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.1714,
    cy: 9.70743,
    r: 0.5,
    transform: "rotate(120 31.1714 9.70743)",
    fill: "#351771"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5373,
    cy: 11.0734,
    r: 0.5,
    transform: "rotate(120 31.5373 11.0734)",
    fill: "#351771"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.0373,
    cy: 8.47525,
    r: 0.5,
    transform: "rotate(120 33.0373 8.47525)",
    fill: "#351771"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.4034,
    cy: 9.84146,
    r: 0.5,
    transform: "rotate(120 33.4034 9.84146)",
    fill: "#351771"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.0014,
    cy: 11.3415,
    r: 0.5,
    transform: "rotate(120 36.0014 11.3415)",
    fill: "#351771"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.3015,
    cy: 7.47305,
    r: 0.5,
    transform: "rotate(120 31.3015 7.47305)",
    fill: "#351771"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.8053,
    cy: 6.60928,
    r: 0.5,
    transform: "rotate(120 31.8053 6.60928)",
    fill: "#351771"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.9393,
    cy: 7.84146,
    r: 0.5,
    transform: "rotate(120 29.9393 7.84146)",
    fill: "#351771"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2072,
    cy: 6.84146,
    r: 0.5,
    transform: "rotate(120 28.2072 6.84146)",
    fill: "#351771"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8412,
    cy: 7.20743,
    r: 0.5,
    transform: "rotate(120 26.8412 7.20743)",
    fill: "#351771"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9393,
    cy: 6.10928,
    r: 0.5,
    transform: "rotate(120 30.9393 6.10928)",
    fill: "#351771"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.6714,
    cy: 7.10928,
    r: 0.5,
    transform: "rotate(120 32.6714 7.10928)",
    fill: "#351771"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5694,
    cy: 6.47305,
    r: 0.5,
    transform: "rotate(120 29.5694 6.47305)",
    fill: "#351771"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9034,
    cy: 14.1715,
    r: 0.5,
    transform: "rotate(120 30.9034 14.1715)",
    fill: "#351771"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.0242,
    cy: 4.42633,
    r: 1,
    transform: "rotate(120 29.0242 4.42633)",
    fill: "#351771"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5732,
    cy: 8.20743,
    r: 0.5,
    transform: "rotate(120 28.5732 8.20743)",
    fill: "#351771"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.8374,
    cy: 5.47305,
    r: 0.5,
    transform: "rotate(120 27.8374 5.47305)",
    fill: "#351771"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.1714,
    cy: 13.1715,
    r: 0.5,
    transform: "rotate(120 29.1714 13.1715)",
    fill: "#351771"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2035,
    cy: 8.5712,
    r: 0.5,
    transform: "rotate(120 27.2035 8.5712)",
    fill: "#351771"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5732,
    cy: 9.93936,
    r: 0.5,
    transform: "rotate(120 27.5732 9.93936)",
    fill: "#351771"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9034,
    cy: 12.4394,
    r: 0.5,
    transform: "rotate(120 31.9034 12.4394)",
    fill: "#351771"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.2694,
    cy: 12.0734,
    r: 0.5,
    transform: "rotate(120 33.2694 12.0734)",
    fill: "#351771"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.6355,
    cy: 13.4394,
    r: 0.5,
    transform: "rotate(120 33.6355 13.4394)",
    fill: "#351771"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.6355,
    cy: 11.7074,
    r: 0.5,
    transform: "rotate(120 34.6355 11.7074)",
    fill: "#351771"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.7694,
    cy: 9.47525,
    r: 0.5,
    transform: "rotate(120 34.7694 9.47525)",
    fill: "#351771"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.0732,
    cy: 5.60928,
    r: 0.5,
    transform: "rotate(120 30.0732 5.60928)",
    fill: "#351771"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5732,
    cy: 11.6715,
    r: 0.5,
    transform: "rotate(120 26.5732 11.6715)",
    fill: "#351771"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.7072,
    cy: 11.1715,
    r: 0.5,
    transform: "rotate(120 25.7072 11.1715)",
    fill: "#351771"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.3412,
    cy: 9.80557,
    r: 0.5,
    transform: "rotate(120 25.3412 9.80557)",
    fill: "#351771"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7072,
    cy: 5.97525,
    r: 0.5,
    transform: "rotate(120 28.7072 5.97525)",
    fill: "#351771"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.4393,
    cy: 6.97525,
    r: 0.5,
    transform: "rotate(120 30.4393 6.97525)",
    fill: "#351771"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.0732,
    cy: 7.34146,
    r: 0.5,
    transform: "rotate(120 29.0732 7.34146)",
    fill: "#351771"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.3412,
    cy: 6.34146,
    r: 0.5,
    transform: "rotate(120 27.3412 6.34146)",
    fill: "#351771"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.7072,
    cy: 7.70743,
    r: 0.5,
    transform: "rotate(120 27.7072 7.70743)",
    fill: "#351771"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.3412,
    cy: 8.07339,
    r: 0.5,
    transform: "rotate(120 26.3412 8.07339)",
    fill: "#351771"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8854 65.0002C28.4854 64.6002 31.0521 55.5002 32.8854 51.0002C34.0521 52.0002 36.7856 54.9002 38.3856 58.5002C40.3856 63.0002 38.3854 65.5002 32.8854 65.0002Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4554 52.5003C12.4547 49.7705 17.7451 48.3004 20.7281 47.9614C20.5315 48.8902 19.7689 51.2314 18.2909 53.1654C16.4434 55.5829 12.4559 54.5002 12.4554 52.5003Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5206 60.0644C17.5193 57.5047 21.4036 52.2486 23.953 49.7443C24.4494 50.7595 25.45 53.5143 25.4812 56.4114C25.5203 60.0328 20.9869 61.9398 19.5206 60.0644Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5807 58.898C40.3334 59.011 38.3674 52.778 37.8416 49.2434C38.9546 49.4391 41.771 50.2501 44.1323 51.9289C47.084 54.0273 45.9599 58.8153 43.5807 58.898Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderStep2);
export default __webpack_public_path__ + "static/media/loader-step-2.5e784210426cb3c2119a80c6cf7f7fc2.svg";
export { ForwardRef as ReactComponent };